import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { showOriginalText, applyChangedLanguage, languageOptions } from "../../../../Navbar/gtUtils";
import Modal from "../../../../UIComponents/CustomModal/Modal";
import { numberWithCommas } from "../utils";

const TranslateWords = (props) => {
    const [selectedLanguage, setSelectedLanguage] = useState({ key: "English", label: "English", value: "en" });

    useEffect(() => {
        translate();
    }, [selectedLanguage]);

    useEffect(() => {
        if (props.open) {
            if (sessionStorage.getItem("googleTranslate")) {
                setSelectedLanguage(languageOptions.find((l) => l.value === sessionStorage.getItem("selectedLanguage")));
            } else {
                setSelectedLanguage({ key: "English", label: "English", value: "en" });
            }
        } else {
            if (sessionStorage.getItem("googleTranslate")) applyChangedLanguage(sessionStorage.getItem("selectedLanguage"));
            else showOriginalText();
        }
    }, [props.open]);

    const translate = () => {
        if (selectedLanguage) applyChangedLanguage(selectedLanguage.value);
    };

    return (
        <Modal className="wordcloud-translate-words" show={props.open} onClose={props.onClose} noSkipGTranslate={true}>
            <Modal.Header className="wordcloud-translate-words-header">Translate OCR Wordcloud Words</Modal.Header>
            <Modal.Content className="wordcloud-translate-words-content" noSkipGTranslate={true}>
                <div className="translate-selector skiptranslate">
                    <span>Translate to</span>
                    <ReactSelect
                        options={languageOptions}
                        placeholder="Select Language"
                        isClearable={false}
                        className="translate-dropdown"
                        isSearchable
                        value={selectedLanguage}
                        onChange={setSelectedLanguage}
                    />
                </div>
                <div className="wordcloud-words-table">
                    <div className="header table-row skiptranslate">
                        <span className="words">Words</span>
                        <span className="translated-word">Translation</span>
                        <span className="word-mentions">Mentions</span>
                    </div>
                    {props.data &&
                        props.data.length &&
                        props.data.map((d) => (
                            <div className="table-row" key={d.name + d.weight}>
                                <span className="words skiptranslate">{d.name}</span>
                                <span className="translated-word">{d.name}</span>
                                <span className="word-mentions skiptranslate">{numberWithCommas(d.weight)}</span>
                            </div>
                        ))}
                </div>
            </Modal.Content>
        </Modal>
    );
};

export default TranslateWords;
